import BaseService from './BaseService'

export class OpenAPIService extends BaseService<Event> {
  constructor() {
    super('openapi/')
  }
}

export default new OpenAPIService()
